import { Box, Typography } from '@mui/material';
import ProgressStatus from 'components/ProgressStatus';
import QueueStatus from 'components/QueueStatus';
import ShopHeader from 'components/ShopHeader';
import WaitNumber from 'components/WaitNumber';
import React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import {
  setWaitAcceptanceQueueStatus,
  WaitAcceptanceQueueStatus,
} from 'store/requestSlice';
import { ReactComponent as BGImage } from 'assets/images/standby/acceptance-image--1.svg';

type WaitAcceptanceProps = {
  waitAcceptanceQueueStatus?: WaitAcceptanceQueueStatus;
};
const WaitAcceptance = (props: WaitAcceptanceProps) => {
  const storeInfo = useSelector((state: RootState) => state.store);
  const receiptInfo = useSelector(
    (state: RootState) => state.receipt.max_priority,
  );
  const extStatusInfo = useSelector(
    (state: RootState) => state.receipt.ext_status,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  if (props.waitAcceptanceQueueStatus !== undefined) {
    dispatch(setWaitAcceptanceQueueStatus(props.waitAcceptanceQueueStatus));
  }
  const bgColor =
    receiptInfo?.f_threshold_wait_order &&
    receiptInfo.f_threshold_wait_order < 2
      ? '#ffffff'
      : '#ffffff';
  const textColor =
    receiptInfo?.f_threshold_wait_order &&
    receiptInfo.f_threshold_wait_order < 2
      ? '#000000'
      : '#000000';
  const waitText =
    receiptInfo?.f_threshold_wait_order &&
    receiptInfo.f_threshold_wait_order < 2 ? (
      <>
        商品お受け取りまで
        <br />
        もう少々お待ちください。
      </>
    ) : (
      <>
        商品お受け取りまで
        <br />
        もう少々お待ちください。
      </>
    );

  useEffect(() => {
    console.log('受取待ち...');
  }, []);

  useEffect(() => {
    const ext_status =
      receiptInfo?.receipt_no &&
      extStatusInfo[receiptInfo.receipt_no]?.ext_state;

    if (
      !(
        receiptInfo?.ticket_status === '500' &&
        ext_status !== '500_adj0_ext' &&
        ext_status !== 'cancel' &&
        receiptInfo?.ticket_adjust_kbn === '0'
      )
    ) {
      navigate('/');
    }
  }, [receiptInfo]);

  return (
    <Box sx={{ backgroundColor: '#E9FDF9', minHeight: '100vh' }}>
      <Box
        sx={{
          backgroundColor: '#c7e4d6',
          background:
            'linear-gradient(180deg, rgba(199,228,214,1) 0%, rgba(199,228,214,1) 98%, rgba(233,253,249,1) 99%, rgba(233,253,249,1) 100%)',
          pt: 6,
        }}
      >
        <Box sx={{ pl: 4, pr: 4 }}>
          <Box>
            <ShopHeader shopName={storeInfo.store_name || ''} />
          </Box>
          <Box sx={{ mt: 4 }}>
            <Box
              sx={{
                backgroundColor: bgColor,
                borderRadius: '15px',
                paddingTop: 4,
                pl: 4,
                pr: 4,
                pb: 4,
              }}
            >
              <Box>
                <Typography
                  textAlign={'center'}
                  sx={{
                    fontSize: 14,
                    lineHeight: 20 / 14,
                    fontWeight: 500,
                    color: textColor,
                  }}
                >
                  現在のステータス
                </Typography>
              </Box>
              <Box sx={{ mt: 2 }}>
                <ProgressStatus
                  items={['測定', '会計', '受取']}
                  currentIndex={2}
                ></ProgressStatus>
              </Box>
              <Box sx={{ mt: 2 }}>
                <Typography
                  textAlign={'center'}
                  sx={{
                    fontSize: 24,
                    lineHeight: 35 / 24,
                    fontWeight: 500,
                    color: textColor,
                  }}
                >
                  受け取り待ち
                </Typography>
              </Box>
              <Box sx={{ mt: '3px' }}>
                <Typography
                  textAlign={'center'}
                  sx={{
                    fontSize: 14,
                    lineHeight: 20 / 14,
                    fontWeight: 500,
                    color: textColor,
                  }}
                >
                  {waitText}
                </Typography>
              </Box>
              <Box sx={{ mt: 2 }}>
                <WaitNumber
                  type={'a'}
                  number={
                    receiptInfo?.ticket_number !== undefined
                      ? receiptInfo.ticket_number
                      : '-'
                  }
                ></WaitNumber>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              mt: 2,
            }}
          >
            <QueueStatus
              label="呼び出しまで"
              mainValuePrefix={'あと'}
              mainValue={
                receiptInfo?.f_threshold_wait_order !== undefined
                  ? receiptInfo.f_threshold_wait_order + ''
                  : '-'
              }
              mainValueUnit={'人'}
            />
          </Box>
        </Box>
        <Box
          sx={{
            mt: 2,
          }}
        >
          <Typography
            textAlign={'center'}
            sx={{ fontSize: 11, lineHeight: 16 / 11, color: '#000' }}
          >
            ※人数や時間は大まかな目安です。順番が前後することがあります。
          </Typography>
        </Box>
        <Box
          sx={{
            mt: '1px',
            '& > svg': {
              display: 'block',
              width: '100%',
              height: 'auto',
            },
          }}
        >
          <BGImage></BGImage>
        </Box>
      </Box>
    </Box>
  );
};
export default WaitAcceptance;
